import { render, staticRenderFns } from "./WorkflowButtons.vue?vue&type=template&id=59694cab&scoped=true&"
import script from "./WorkflowButtons.vue?vue&type=script&lang=ts&"
export * from "./WorkflowButtons.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowButtons.vue?vue&type=style&index=0&id=59694cab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59694cab",
  null
  
)

export default component.exports